<template lang="">
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">路珠分析</span>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <DateFilterTab v-model="selectDate" @sendLeftHandle="doChange" />
      </div>
    </div>
    <TrendExplanation />
    <!-- 名次與路珠筛選 -->
    <div class="content-8__controlbar">
      <SingleSelectGroup
        key="type"
        v-model="selectSingleType"
        :filter-data="getItemList('singleType')"
        title="筛选路珠"
      />
    </div>

    <!-- 資料顯示 -->
    <div v-if="rowData.length > 0 && !isLoading" class="content-8__content">
      <div
        v-for="(group, index) in filterData"
        :key="`${group.field}_${group.ruleType}_${index}`"
        class="luzhutable"
      >
        <div class="luzhutable__head">
          <div class="luzhutable__head__left">
            <div class="luzhutable-group">
              <span class="head-text">连续出现</span>
              <div class="inputbox">
                <input
                  :key="`${group.field}-count-${group.ruleType}-${mode}`"
                  :ref="`${group.field}-count-${group.ruleType}`"
                  class="inputbox__input"
                  type="number"
                  min="1"
                  value="0"
                >
              </div>
              <span class="head-text">次以上</span>
              <div class="selectbox">
                <select
                  :key="`${group.field}-type-${group.ruleType}-${mode}`"
                  :ref="`${group.field}-type-${group.ruleType}`"
                  class="selectbox__select"
                >
                  <template v-for="(total, totalIndex) in luZhuSortMapping">
                    <option
                      v-if="group.totals[total.key] || isHeZero(total.key, group.ruleType, group.field)"
                      :key="`sort-${totalIndex}`"
                      :value="total.key"
                    >
                      <template> {{ total.key | ballType }} </template>
                    </option>
                  </template>
                </select>
              </div>
              <a
                class="button-primary active"
                @click.prevent="handleSortLight(group)"
              >
                <span class="button-primary__text">确定</span>
              </a>
            </div>
            <div class="luzhutable-group">
              <span class="head-text">出现的次数:</span>
              <span
                :ref="`${group.field}-${group.ruleType}-value`"
                class="head-text"
              >{{ getCount(`${group.field}-${group.ruleType}`) }}</span>
            </div>
          </div>
          <div class="luzhutable__head__right">
            <div class="luzhutable-group">
              <span class="head-text">今日累计:</span>
              <template v-for="(mappingItem, sortIndex) in luZhuSortMapping">
                <span
                  v-if="group.totals[mappingItem.key]"
                  :key="`sort-${sortIndex}`"
                >
                  <template>{{ mappingItem.key | ballType }}({{ group.totals[mappingItem.key] }}) </template>
                </span>
                <span
                  v-else-if="isHeZero(mappingItem.key, group.ruleType, group.field)"
                  :key="`sort-${sortIndex}`"
                >
                  和(0)
                </span>
              </template>
            </div>
            <div class="luzhutable-group">
              <span class="head-text red">{{
                group.ruleType | groupName
              }}</span>
              <span class="head-text red">最新↓</span>
            </div>
          </div>
        </div>
        <div class="luzhutable-scroll">
          <div
            :ref="`${group.field}-${group.ruleType}`"
            class="luzhutable__content"
          >
            <div
              v-for="(point, pointIndex) in group.roadBeads"
              :key="`point-${pointIndex}`"
              class="luzhutable__content__item"
              :class="handleHighlight(group, point)"
              :style="{'width': moreWidth ? '50px' : '40px'}"
            >
              <div class="textbox">
                <div
                  v-for="(pointItem, pointItemIndex) in point"
                  :key="`point-item-${pointItemIndex}`"
                  class="textbox__item"
                  :class="textColor(pointItem)"
                >
                  <span class="textbox__item__text">{{
                    pointItem | ballType
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoData v-if="rowData.length === 0 && !isLoading" />
    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import TrendExplanation from '@/components/web/pages/trend/TrendExplanation/index'
import SingleSelectGroup from '@/components/web/common/SingleSelectGroup'
import { getRoadBallCount_mobile } from '@/api/mobile/roadball'
import DateFilterTab from '@/components/web/pages/trend/DateFilterTab'

import { filterMapping } from '@/utils/luJhu/filterMapping'

import { commonMethodMixin } from '@/components/web/common/mixins/luJhuFenSi.js'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'

export default {
  name: 'KL8',
  components: {
    SingleSelectGroup,
    DateFilterTab,
    TrendExplanation,
    Loading,
    NoData
  },
  filters: {
    // 球種類型翻譯
    ballType(value) {
      switch (value) {
        case 'danshuang_dan':
          return '单'
        case 'danshuang_shuang':
          return '双'
        case 'daxiao_da':
          return '大'
        case 'daxiao_xiao':
          return '小'
        case 'longHu_long':
          return '龙'
        case 'longHu_hu':
          return '虎'
        case 'daxiao_he':
        case 'longHu_he':
        case 'danshuang_he':
          return '和'
        case 'maJiang_bai':
          return '白'
        case 'maJiang_fa':
          return '发'
        case 'maJiang_jhong':
          return '中'
        case 'fangSiang_dong':
          return '东'
        case 'fangSiang_nan':
          return '南'
        case 'fangSiang_si':
          return '西'
        case 'fangSiang_bei':
          return '北'
        case 'wuXing_mu':
          return '木'
        case 'wuXing_jin':
          return '金'
        case 'wuXing_tu':
          return '土'
        case 'wuXing_huo':
          return '火'
        case 'wuXing_shuei':
          return '水'
        case 'danShuangPan_shuang':
          return '双多'
        case 'danShuangPan_dan':
          return '单多'
        case 'danShuangPan_he':
          return '单双和'
        case 'daXiaoPan_da':
          return '前多'
        case 'daXiaoPan_xiao':
          return '后多'
        case 'daXiaoPan_he':
          return '前后和'
        default:
          console.error('错误球种类别', value)
          return value
      }
    },
    // 類別翻譯
    groupName(value) {
      switch (value) {
        case 'hmDanShuang':
        case 'guanYaHeDanShuang':
          return '单双'
        case 'zongHeDanShuang':
          return '总合单双'
        case 'hmDaXiao':
          return '大小'
        case 'zongHeDaXiao':
          return ' 总和大小'
        case 'zuLongHu':
        case 'longHu':
          return '龙虎'
        case 'daxiao_he':
          return '和'
        case 'guanYaHeDaXiao':
          return '大小'
        case 'fangWei':
          return '东南西北'
        case 'zhongFaBai':
          return '中发白'
        case 'hmHeDanShuang':
          return '合数单双'
        case 'hmWeiShuDaXiao':
          return '尾數大小'
        case 'wuXing':
          return '总和五行'
        case 'hmDaXiaoPan':
          return '前后和'
        case 'hmDanShuangPan':
          return '单双和'
        default:
          console.error('错误分组类别名称', value)
          return value
      }
    }
  },
  mixins: [commonMethodMixin],
  props: {
    lotteryType: {
      type: String,
      default: '',
      required: true
    }
  },
  data: function() {
    return {
      loading: true,
      selectSingleType: '',
      rowData: [],
      mode: 'combine',
      hightlightObj: {},
      selectDate: '',
      luZhuSortMapping: [
        { key: 'daxiao_da', label: '大' },
        { key: 'daxiao_xiao', label: '小' },
        { key: 'danshuang_dan', label: '单' },
        { key: 'danshuang_shuang', label: '双' },
        { key: 'daXiaoPan_da', label: '前多' },
        { key: 'daXiaoPan_xiao', label: '后多' },
        { key: 'daXiaoPan_he', label: '前后和' },
        { key: 'danShuangPan_dan', label: '单多' },
        { key: 'danShuangPan_shuang', label: '双多' },
        { key: 'danShuangPan_he', label: '单双和' },
        { key: 'wuXing_jin', label: '金' },
        { key: 'wuXing_mu', label: '木' },
        { key: 'wuXing_shuei', label: '水' },
        { key: 'wuXing_huo', label: '火' },
        { key: 'wuXing_tu', label: '土' },

        { key: 'danshuang_he', label: '和' },
        { key: 'daxiao_he', label: '和' }
      ]
    }
  },
  computed: {
    filterData() {
      const filterData = this.rowData.filter((item) => {
        return (
          this.selectSingleType.includes(item.ruleType) && item.field === 'all'
        )
      })
      return filterData
    },
    // for 前後和及單雙和 三個字加大欄寬
    moreWidth() {
      return ['hmDaXiaoPan', 'hmDanShuangPan'].includes(this.selectSingleType)
    }
  },
  watch: {
    selectDate(newValue) {
      this.getLuJhuData(newValue)
    },
    selectSingleType() {
      this.initHighLightObj(this.rowData)
    }
  },
  created() {
    this.init()
    // 单選路珠
    this.selectSingleType = 'zongHeDaXiao'
  },
  methods: {
    init() {
      this.getLuJhuData('30')
    },
    async getLuJhuData(query) {
      this.isLoading = true
      const code = this.$route.params.lottery_code
      const rules =
        'zongHeDaXiao,zongHeDanShuang,hmDaXiaoPan,hmDanShuangPan,wuXing'
      const form = {}

      if (/^\d{2}$/.test(query)) {
        form.count = query
      } else {
        form.date = query
      }

      const [data, error] = await getRoadBallCount_mobile({
        code,
        rules,
        ...form
      })
      if (error) {
        console.log(error)
        return
      }

      this.initHighLightObj(data)
      this.isLoading = false
      this.rowData = data
    },
    getItemList(name) {
      const type = this.lotteryType

      return filterMapping[type].typeText
    },
    // 判斷是否要顯示 和(0)
    isHeZero(openType, ruleType, field) {
      // 大小和
      if (openType === 'daxiao_he' && ruleType === 'zongHeDaXiao' && field === 'all') {
        return true
      }

      return false
    }
  }
}
</script>
